import FirebaseContext, { withFirebase } from './context';
import Firebase from './firebase';
import { DATA_MODEL, FIREBASE_ENV } from './config';

export default Firebase;

export { FirebaseContext, withFirebase, FIREBASE_ENV, DATA_MODEL };
